import { Redirect, useLocalSearchParams } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ giftCardId: string }>();

  return <Redirect withAnchor href={{ pathname: '/account/gift/redeem/[giftCardId]', params }} />;
}
